<template>
  <li class="result-card">
    <details class="result-card__details">
      <summary class="result-card__summary">
        <div class="result-card__summary-text">
          <span class="result-card__title">{{ result?.name }}</span>
          <span class="result-card__meta">{{ result?.launchDate }}</span>
        </div>
        <span class="icon icon--arrow-down-bold"></span>
      </summary>

      <div class="result-card__content">
        <dl class="result-card__fields">
          <div class="result-card__field" v-for="(config, dataKey) in visibleColumns" :key="dataKey">
            <dt>{{ config.displayName }}:</dt>
            <dd>{{ getColumnValue(result, dataKey) }}</dd>
          </div>
        </dl>

        <button class="button button--secondary result-card__button" type="button" @click="openDetails(result?.uuid)">
          Läs mer
        </button>
      </div>
    </details>
  </li>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { IColumnItem } from '@/interfaces/search/IQueryColumn';
import { ISearchResultItem } from '@/interfaces/search/ISearchResultItem';
import { useUtil } from '@/services/util-service';

const props = defineProps<{
  result: ISearchResultItem;
  columnConfig: Record<string, IColumnItem>;
}>();

const router = useRouter();
const emptyFieldValue = "-";

const visibleColumns = computed(() => {
  return Object.fromEntries(
    Object.entries(props.columnConfig).filter(([dataKey, config]) => {
      return config.visible && dataKey !== 'name';
    })
  );
});

const getColumnValue = (result: ISearchResultItem | undefined, dataKey: string): string | number => {
  if (!result) {
    return emptyFieldValue;
  }

  const value = result[dataKey];
  if (value == null) {
    return emptyFieldValue;
  }

  if (dataKey === "length" || dataKey === "width") {
    return typeof value === "number" ? `${useUtil().formatNumber(value)} meter` : emptyFieldValue;
  }

  if (Array.isArray(value)) {
    const values = value.filter((item) => item.trim() !== "");
    return values.length ? values.join(", ") : emptyFieldValue;
  }

  if (typeof value === "string") {
    return value.trim() ? value : emptyFieldValue;
  }

  return value;
};

const openDetails = (shipId: string | null | undefined) => {
  if (!shipId) {
    return;
  }

  router.push({ name: 'Details', params: { shipId: shipId } });
};
</script>
